/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_aria_email_info = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email info`)
};

const zh_hans1_aria_email_info = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邮箱说明`)
};

const zh_hant1_aria_email_info = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電子郵件資訊`)
};

const fr_aria_email_info = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infos e-mail`)
};

const de_aria_email_info = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Info`)
};

const ja_aria_email_info = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メール情報`)
};

const ko_aria_email_info = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일 정보`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const aria_email_info = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.aria_email_info(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("aria_email_info", locale)
	if (locale === "en") return en_aria_email_info(inputs)
	if (locale === "zh-Hans") return zh_hans1_aria_email_info(inputs)
	if (locale === "zh-Hant") return zh_hant1_aria_email_info(inputs)
	if (locale === "fr") return fr_aria_email_info(inputs)
	if (locale === "de") return de_aria_email_info(inputs)
	if (locale === "ja") return ja_aria_email_info(inputs)
	return ko_aria_email_info(inputs)
};